import styled from 'styled-components';
import { device } from '../../../util/commonMediaStylesUtil';

export const PersonalContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 30px;
  top: 20px;
  left: 20px;
  background-color: #eaeaf2;

  ${device.laptop_sm`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  `}

  ${device.tablet`
    display: flex;
    flex-direction: column;
    gap: 15px;
  `}
`;

export const ProfileCardContainer = styled.div`
  width: 33%;
  // width: 30%; //with datacard 3
  padding: 16px;
  border: 1px solid #c4c4cd;
  gap: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background-color: #ffffff;

  ${device.laptop_sm`
    width: 100%;
  `}
`;

export const ProfileCardContainerPL = styled.div`
  width: 30%;
  padding: 16px;
  border: 1px solid #c4c4cd;
  gap: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background-color: #ffffff;

  ${device.laptop_sm`
    width: 100%;
  `}
`;

export const ImageContainer = styled.div`
  width: 120px;
  gap: 10px;
  display: flex;
  align-items: center;
`;
export const Image = styled.div`
  width: 120px;
  height: 120px;
`;

export const ProfileImageStyled = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 60px;
`;

export const DetailsContainer = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ProfileTitle = styled.h1`
  font-family: EYInterstate;
  font-size: 28px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const ProfileLine = styled.h6`
  font-family: EYInterstate;
  font-size: 14px;
  font-weight: 300;
  color: #747480;
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const MoreiconContainer = styled.div`
  width: 30px;
  color: #2e2e38;
`;

// DataCardOne
export const DataCardContainer = styled.div`
  border: 1px solid #c4c4cd;
  width: 33%;
  // width: 22%; //with datacard 3
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #ffffff;

  ${device.laptop_sm`
    width: 100%;
  `}
`;

export const DataCardContainerPL = styled.div`
  border: 1px solid #c4c4cd;
  width: 22%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #ffffff;

  ${device.laptop_sm`
    width: 100%;
  `}
`;

export const CardTitle = styled.div`
  width: auto;
  max-width: 176px;
  height: 22px;
  font-family: EYInterstate;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #2e2e38;
  white-space: nowrap;
`;

export const CardTitleTwo = styled(CardTitle)`
  max-width: 165px;
`;

export const CardTitleThree = styled.div`
  height: 22px;
  font-family: EYInterstate;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TitleContainer = styled.div`
  height: 22px;
  gap: 8px;
  display: flex;
  flex-direction: row;
  color: #2e2e38;
`;

//DataCardTwo
export const TitleContainerTwo = styled(TitleContainer)`
  width: 189px;
`;

export const TitleContainerThree = styled(TitleContainer)``;

export const DataContainer = styled.div`
  height: 73.5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  color: #1a1a24;
`;

export const DataContainerTwo = styled(DataContainer)`
  height: 38px;
`;

export const Value = styled.div`
  width: 120px;
  font-family: EYInterstate;
  font-size: 24px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: center;
  display: flex;
  justify-content: flex-start;
`;

export const ValueTwo = styled(Value)`
  width: 70px;
  margin-bottom: 20px;

  ${device.laptop_sm`
  width: 120px;
`}
`;

// Labels
export const Labels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LabelLine1 = styled.div`
  font-family: EYInterstate;
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
`;

export const LabelLine2 = styled(LabelLine1)``;

export const LabelLineTwo = styled(LabelLine1)`
  margin-bottom: 14px;
  justify-content: center;
`;

export const LabelLineThree = styled(LabelLine1)`
  justify-content: center;
  white-space: nowrap;
`;

export const Separator = styled.div`
  height: 1px;
  background-color: #c4c4cd;
`;
